import {get} from './apiMethods';
import fetch from 'node-fetch';
import {cmURL} from './config';

export const observation = (series_id, date_from, date_to) => get(`observation?series_id=${series_id}&date_from=${date_from}&date_to=${date_to}`);
// export const observation = (series_id, date_from, date_to) => get(`observation/${series_id}`);

export const content = {
  fetch: path => fetch(`${cmURL}/api-public/${path}`)
};

// export const preview = {
//   fetch: url => $.ajax({
//     // url: "http://api.linkpreview.net",
//     url: 'http://localhost:3000/link-preview',
//     dataType: 'jsonp',
//     data: {url}
//   })
// };

export const preview = {
  fetch: url => fetch(`${cmURL}/link-preview?url=${url}`).then(res => res.json())
};


// WEBPACK FOOTER //
// ./src/libs/api.js